export const common = {
  nav: {
    home: 'หน้าแรก',
    about: 'เกี่ยวกับที่พัก',
    rooms: 'ห้องพัก',
    gallery: 'แกลเลอรี่',
    reservation: 'จอง',
    access: 'การเดินทาง',
    contact: 'ติดต่อเรา',
    forOwners: 'สำหรับเจ้าของที่พัก',
    freeConsultation: 'ปรึกษาฟรี',
  },
  hero: {
    title: 'ที่ซึ่งประเพณีพบกับ',
    subtitle: 'ความสะดวกสบายสมัยใหม่',
    description: 'สัมผัสเสน่ห์แท้จริงของบ้านญี่ปุ่นดั้งเดิมในมาโกเมะ เขตโอตะ โตเกียว ผสมผสานความงามทางประวัติศาสตร์กับความสะดวกสบายร่วมสมัยอย่างลงตัว',
    bookNow: 'จองเลย',
    viewGallery: 'ดูแกลเลอรี่',
  },
  about: {
    title: 'เกี่ยวกับที่พัก',
    subtitle: 'การผสมผสานที่กลมกลืนระหว่างสถาปัตยกรรมญี่ปุ่นดั้งเดิมและความสะดวกสบายสมัยใหม่',
    description: 'บ้านมาโกเมะดั้งเดิมเป็นบ้านญี่ปุ่นที่ได้รับการบูรณะอย่างสวยงาม ตั้งอยู่ในย่านที่พักอาศัยอันเงียบสงบของมาโกเมะ เขตโอตะ โตเกียว ได้รับการปรับปรุงอย่างพิถีพิถันเพื่อรักษาเสน่ห์ดั้งเดิมพร้อมมอบสิ่งอำนวยความสะดวกสมัยใหม่',
    feature1Title: 'เช่าทั้งหลัง',
    feature1Desc: 'เพลิดเพลินกับความเป็นส่วนตัวอย่างสมบูรณ์กับครอบครัวและเพื่อนๆ',
    feature2Title: 'ครัวครบครัน',
    feature2Desc: 'ครัวที่มีอุปกรณ์ครบครันสำหรับปรุงอาหารที่คุณชื่นชอบ',
    feature3Title: 'รองรับได้ถึง 8 คน',
    feature3Desc: 'ที่พักกว้างขวางเหมาะสำหรับกลุ่มและครอบครัว',
    feature4Title: 'ห้องทาทามิดั้งเดิม',
    feature4Desc: 'ห้องญี่ปุ่นแท้ๆ พร้อมเสื่อทาทามิและความอบอุ่นของไม้',
  },
  rooms: {
    title: 'ห้องพัก',
    subtitle: 'ผ่อนคลายในพื้นที่สไตล์ญี่ปุ่นดั้งเดิม',
    room1: 'ผังพื้น',
    room2: 'ครัวครบครัน',
    room3: 'เตียงเสริม',
    capacity: 'ความจุสูงสุด',
    guests: '8 คน',
    amenities: 'สิ่งอำนวยความสะดวก',
    amenitiesList: 'ครัวครบครัน, ตู้เย็น, ไมโครเวฟ, อุปกรณ์ทำอาหาร, ภาชนะ, Wi-Fi, เครื่องปรับอากาศ, เครื่องทำความร้อน, เครื่องซักผ้า, ห้องน้ำ, ห้องส้วม, ผ้าขนหนู, ของใช้ส่วนตัว',
  },
  gallery: {
    title: 'แกลเลอรี่',
    subtitle: 'ค้นพบความงามของบ้านมาโกเมะดั้งเดิม',
  },
  reservation: {
    title: 'การจอง',
    subtitle: 'จองการพักผ่อนพิเศษของคุณ',
    name: 'ชื่อ-นามสกุล',
    email: 'อีเมล',
    phone: 'หมายเลขโทรศัพท์',
    checkin: 'เช็คอิน',
    checkout: 'เช็คเอาท์',
    guests: 'จำนวนผู้เข้าพัก',
    message: 'คำขอพิเศษ',
    submit: 'ส่งคำขอจอง',
    submitting: 'กำลังส่ง...',
    success: 'ได้รับคำขอจองของคุณแล้ว เราจะติดต่อกลับในเร็วๆ นี้',
    error: 'ส่งไม่สำเร็จ กรุณาลองอีกครั้ง',
    bookingPlatforms: 'คุณยังสามารถจองผ่านแพลตฟอร์มเหล่านี้',
    bookOnAirbnb: 'ตรวจสอบความพร้อมและจองบน Airbnb',
    bookOnJalan: 'ตรวจสอบความพร้อมและจองบน Jalan',
    orDirectBooking: 'หรือติดต่อเราโดยตรง',
    required: 'จำเป็น',
    guestsPlaceholder: '― กรุณาเลือก ―',
    guestSingular: 'คน',
    guestPlural: 'คน',
    messagePlaceholder: 'มีคำขอพิเศษหรือคำถามไหม? เขียนได้เลย (ไม่เกิน 500 ตัวอักษร)',
    confirmNote: '※ เราจะติดต่อกลับหลังจากยืนยันคำขอจองของคุณ',
  },
  contact: {
    title: 'ติดต่อเรา',
    subtitle: 'อย่าลังเลที่จะติดต่อหากมีคำถามหรือข้อสงสัย',
    name: 'ชื่อ-นามสกุล',
    email: 'อีเมล',
    subject: 'หัวข้อ',
    message: 'ข้อความ',
    submit: 'ส่ง',
    submitting: 'กำลังส่ง...',
    success: 'ได้รับข้อความของคุณแล้ว เราจะติดต่อกลับในเร็วๆ นี้',
    error: 'ส่งไม่สำเร็จ กรุณาลองอีกครั้ง',
    address: 'ที่อยู่',
    addressDetail: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    access: 'การเดินทาง',
    accessDetail: 'เดิน 8 นาทีจากสถานี Magome (Toei Asakusa Line)',
    faqBannerTitle: 'ก่อนส่ง กรุณาตรวจสอบ FAQ ของเรา',
    faqBannerDesc: 'เราได้ตอบคำถามทั่วไปมากมายเกี่ยวกับราคา ขั้นตอน และการจัดการแล้ว',
    faqBannerBtn: 'ดู FAQ',
    accessInfoTitle: 'ข้อมูลการเดินทาง',
    sendMessageTitle: 'ส่งข้อความ',
    inquiryType: 'ประเภทการสอบถาม',
    inquiryTypePlaceholder: 'เลือกประเภทการสอบถาม',
    inquiryOptions: {
      minpaku: 'การลงทะเบียน Minpaku / ขอใบอนุญาต',
      ryokan: 'การขอใบอนุญาต Ryokan',
      management: 'การจัดการทรัพย์สิน / การดำเนินงาน',
      pricing: 'ราคา / แผน',
      marketing: 'รายการ Airbnb / การตลาด',
      revenue: 'การจำลองรายได้',
      other: 'อื่นๆ',
    },
    messagePlaceholder: 'กรุณาอธิบายการสอบถามของคุณ (ไม่เกิน 500 ตัวอักษร)',
    detailLabel: 'รายละเอียดการปรึกษา',
    detailPlaceholder: 'กรุณาระบุที่ตั้ง สถานการณ์ปัจจุบัน และความต้องการของคุณ (ไม่เกิน 500 ตัวอักษร)',
  },
  access: {
    label: 'การเดินทาง',
    title: 'การเดินทางและแผนที่',
    subtitle: 'ตั้งอยู่ในย่านที่พักอาศัยอันเงียบสงบของ Higashi-Magome เขตโอตะ โตเกียว',
    addressLabel: 'ที่อยู่',
    addressLine1: '1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    addressLine2: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    trainLabel: 'โดยรถไฟ',
    trainLine1: 'เดิน 2 นาทีจากสถานี Magome (Toei Asakusa Line)',
    trainLine2: '',
    busLabel: 'โดยรถบัส',
    busLine1: 'เดิน 2 นาทีจากป้าย "Magome Ekimae" (Toei Bus)',
    busLine2: '',
    parkingLabel: 'ที่จอดรถ',
    parkingLine1: 'มีที่จอดรถแบบเหรียญใกล้เคียง',
    parkingLine2: 'กรุณาติดต่อเราหากเดินทางมาด้วยรถยนต์',
    openMap: 'เปิดใน Google Maps',
  },
  footer: {
    description: 'ที่พักบ้านญี่ปุ่นดั้งเดิมในมาโกเมะ เขตโอตะ โตเกียว สัมผัสความกลมกลืนระหว่างความงามญี่ปุ่นและความสะดวกสบายสมัยใหม่',
    quickLinks: 'ลิงก์ด่วน',
    followUs: 'ติดตามเรา',
    rights: 'สงวนลิขสิทธิ์',
    napTitle: 'สำนักงาน Yokota — บัญชีและภาษี',
    napAddress: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: 'โทร: กรุณาติดต่อเรา',
    napServiceArea: 'พื้นที่ให้บริการ: เขตโอตะและโตเกียวทั้งหมด',
    napAccess: 'Toei Asakusa Line — สถานี Magome',
  },
  stickyButton: {
    title: 'ปรึกษาฟรี 30 นาที',
    subtitle: 'ปรึกษา',
  },
  ownersBanner: {
    subtitle: 'สำหรับเจ้าของที่พักที่กำลังพิจารณา Airbnb ในโตเกียว',
    linkText: 'เรียนรู้เกี่ยวกับบริการสนับสนุนสำหรับเจ้าของที่พัก →',
  },
  airbnbLead: {
    title: 'คิดจะเริ่ม Airbnb ในโตเกียวหรือเปล่า?',
    description: 'เราให้การสนับสนุนครบวงจร ตั้งแต่การลงทะเบียน Minpaku และการขอใบอนุญาต Ryokan ไปจนถึงการจัดการทรัพย์สินอย่างเต็มรูปแบบ ตั้งฐานอยู่ในเมืองโอตะพร้อมประสบการณ์การดำเนินงานจริง',
    ctaButton: 'รับคำปรึกษาฟรี',
    badge1: 'ปรึกษาโดยไม่มีข้อผูกมัด',
    badge2: 'ประสบการณ์การดำเนินงานจริง',
    badge3: 'สนับสนุนครบวงจรตั้งแต่การขอใบอนุญาตถึงการจัดการ',
  },
  trust: {
    badge: 'ทำไมต้องเลือกเรา',
    title: 'ได้รับความไว้วางใจจากเจ้าของที่พักในโตเกียว',
    subtitle: 'เราผสมผสานประสบการณ์การดำเนินงานจริงกับการสนับสนุนที่ครอบคลุมเพื่อช่วยให้คุณประสบความสำเร็จ',
    point1Title: 'ประสบการณ์ Airbnb จริง',
    point1Description: 'เราดำเนินงานที่พักดั้งเดิมของเราเองในเมืองโอตะ คำแนะนำของเราอิงจากประสบการณ์จริง ไม่ใช่ทฤษฎี',
    point2Title: 'สนับสนุนการขอใบอนุญาตครบวงจร',
    point2Description: 'ตั้งแต่การลงทะเบียน Minpaku ไปจนถึงการขอใบอนุญาต Ryokan เราจัดการเอกสารและการติดต่อหน่วยงานทั้งหมด',
    point3Title: 'การเพิ่มรายได้สูงสุด',
    point3Description: 'กลยุทธ์การกำหนดราคาที่ขับเคลื่อนด้วยข้อมูลจากตลาดโตเกียวจริง รายได้เพิ่มขึ้นเฉลี่ย 30%+ สำหรับลูกค้าของเรา',
    point4Title: 'บริการแขก 24/7',
    point4Description: 'การสื่อสารกับแขกหลายภาษาตลอด 24 ชั่วโมง เพื่อให้คุณมุ่งเน้นที่การสร้างรายได้ ไม่ใช่การจัดการ',
    point5Title: 'รายงานที่โปร่งใส',
    point5Description: 'รายงานรายได้รายเดือนและโครงสร้างค่าธรรมเนียมที่ชัดเจน ไม่มีค่าใช้จ่ายซ่อนเร้น ไม่มีเรื่องน่าประหลาดใจ',
    ctaButton: 'สำรวจบริการของเรา',
  },
  howItWorks: {
    title: 'วิธีการทำงาน',
    subtitle: 'กระบวนการที่เรียบง่ายและโปร่งใสตั้งแต่การปรึกษาจนถึงการเปิดตัวที่ประสบความสำเร็จ',
    step1Number: '01',
    step1Title: 'ปรึกษาฟรี',
    step1Desc: 'แบ่งปันรายละเอียดและเป้าหมายของทรัพย์สินของคุณ เราให้คำแนะนำที่ซื่อสัตย์เกี่ยวกับการขอใบอนุญาต ศักยภาพรายได้ และขั้นตอนต่อไป',
    step2Number: '02',
    step2Title: 'ประเมินทรัพย์สิน',
    step2Desc: 'เราประเมินความเหมาะสมของทรัพย์สินของคุณ ระบุข้อกำหนด และสร้างแผนปฏิบัติการที่ปรับแต่งเฉพาะ',
    step3Number: '03',
    step3Title: 'เปิดตัวและสนับสนุน',
    step3Desc: 'ตั้งแต่การยื่นขอใบอนุญาตไปจนถึงการจัดการแขก เราจัดการทุกอย่างเพื่อให้คุณมุ่งเน้นที่การสร้างรายได้',
    ctaButton: 'จองการปรึกษาฟรีของคุณ',
    ctaNote: '30 นาที • ไม่มีข้อผูกมัด • แผนงานที่ชัดเจน',
  },
  urgency: {
    title: 'คิดจะเริ่ม Airbnb ในโตเกียวหรือเปล่า?',
    description: 'กฎการขอใบอนุญาตมีความซับซ้อนและข้อผิดพลาดอาจทำให้การเปิดตัวล่าช้า รับคำแนะนำที่ชัดเจนและปฏิบัติได้จริงก่อนตัดสินใจ',
    ctaButton: 'จองการปรึกษาฟรี',
    note: 'ปรึกษา 30 นาที • ไม่มีข้อผูกมัด • ประสบการณ์จริง',
  },
  trustRisk: {
    title: 'ปรึกษาโดยไม่มีแรงกดดัน',
    description: 'เราให้คำแนะนำที่ปฏิบัติได้จริงอิงจากประสบการณ์จริง แม้คุณตัดสินใจไม่ดำเนินการต่อ คุณก็จะได้รับแผนงานที่ชัดเจน',
    badge1Title: 'ไม่มีข้อผูกมัด',
    badge1Desc: 'คำแนะนำฟรีโดยไม่มีแรงกดดัน',
    badge2Title: 'ประสบการณ์จริง',
    badge2Desc: 'เราดำเนินงานทรัพย์สินของเราเอง',
    badge3Title: 'แผนงานที่ชัดเจน',
    badge3Desc: 'คำแนะนำที่นำไปปฏิบัติได้ทันที',
    whatYouGetTitle: 'สิ่งที่คุณจะได้รับจากการปรึกษาของเรา',
    item1: 'การประเมินศักยภาพของทรัพย์สินของคุณอย่างซื่อสัตย์',
    item2: 'คำอธิบายที่ชัดเจนเกี่ยวกับข้อกำหนดการขอใบอนุญาตและระยะเวลา',
    item3: 'การคาดการณ์รายได้ที่สมจริงตามที่ตั้งของคุณ',
    item4: 'แผนงานทีละขั้นตอนที่คุณสามารถปฏิบัติตามได้อย่างอิสระ',
    ctaButton: 'นัดหมายการปรึกษาฟรีของคุณ',
    ctaNote: 'เปิดให้บริการวันจันทร์–ศุกร์ 9:00–18:00 JST',
  },
  faq: {
    title: 'คำถามที่พบบ่อย',
    subtitle: 'คำถามทั่วไปเกี่ยวกับการเริ่มต้นและดำเนินธุรกิจ Airbnb และ Minpaku ในโตเกียว',
    ctaText: 'มีคำถามเพิ่มเติม? เราพร้อมช่วยเหลือ',
    ctaButton: 'จองการปรึกษาฟรี',
    q1: 'จะเริ่ม Airbnb ในโตเกียวได้อย่างไร?',
    a1: 'การเริ่ม Airbnb ในโตเกียวต้องได้รับใบอนุญาตที่เหมาะสม มีสองตัวเลือกหลัก: การลงทะเบียน Minpaku หรือใบอนุญาต Ryokan Minpaku อนุญาตให้ดำเนินการได้สูงสุด 180 วันต่อปีและต้องลงทะเบียนกับหน่วยงานท้องถิ่น ใบอนุญาต Ryokan อนุญาตให้ดำเนินการตลอดทั้งปีแต่ต้องปฏิบัติตามมาตรฐานสิ่งอำนวยความสะดวกและกฎระเบียบความปลอดภัยจากอัคคีภัยที่เข้มงวดกว่า',
    q2: 'ความแตกต่างระหว่าง Minpaku และใบอนุญาต Ryokan คืออะไร?',
    a2: 'Minpaku เป็นการลงทะเบียนที่พักอาศัยที่อนุญาตให้เจ้าของทรัพย์สินเช่าบ้านได้สูงสุด 180 วันต่อปี มีข้อกำหนดที่ง่ายกว่าแต่มีข้อจำกัดในการดำเนินงาน Ryokan เป็นใบอนุญาตธุรกิจที่พักอาศัยอย่างง่ายที่อนุญาตให้ดำเนินการตลอดทั้งปีโดยไม่มีข้อจำกัดด้านวัน แต่ต้องปฏิบัติตามมาตรฐานสิ่งอำนวยความสะดวก อุปกรณ์ความปลอดภัยจากอัคคีภัย และการตรวจสอบเป็นประจำที่เข้มงวดกว่า',
    q3: 'ชาวต่างชาติสามารถเริ่ม Airbnb ในญี่ปุ่นได้หรือไม่?',
    a3: 'ใช่ ชาวต่างชาติสามารถเริ่มธุรกิจ Airbnb ในญี่ปุ่นได้ แต่มีข้อกำหนดสำคัญ คุณต้องมีสถานะการพำนักที่เหมาะสมที่อนุญาตให้ทำกิจกรรมทางธุรกิจในญี่ปุ่น ต้องมีกรรมสิทธิ์ในทรัพย์สินหรือสัญญาเช่าที่ถูกต้อง และต้องกำหนดตัวแทนการจัดการที่อาศัยอยู่ในญี่ปุ่นและสามารถตอบสนองต่อปัญหาได้ภายใน 30 นาที',
    q4: 'การลงทะเบียน Minpaku ในโตเกียวใช้เวลานานแค่ไหน?',
    a4: 'การลงทะเบียน Minpaku ในโตเกียวโดยทั่วไปใช้เวลา 2-4 เดือนตั้งแต่การเตรียมการเริ่มต้นจนถึงการอนุมัติ ระยะเวลารวมถึง: การประเมินและเตรียมทรัพย์สิน (2-3 สัปดาห์) การเตรียมเอกสารและการตรวจสอบความปลอดภัยจากอัคคีภัย (2-4 สัปดาห์) การยื่นต่อรัฐบาลท้องถิ่น (1-2 สัปดาห์) และการอนุมัติและลงทะเบียนขั้นสุดท้าย (1-2 สัปดาห์)',
    q5: 'ค่าใช้จ่ายในการเริ่มต้นเท่าไหร่?',
    a5: 'ค่าใช้จ่ายแตกต่างกันขึ้นอยู่กับขอบเขตของบริการและสภาพทรัพย์สินของคุณ เราเสนอแผนที่รวมการสนับสนุนการยื่นขอ การเตรียมเอกสาร และการประเมินในสถานที่ สำหรับบริการจัดการทรัพย์สิน เราใช้โครงสร้างค่าธรรมเนียมตามผลงาน ซึ่งเป็นเปอร์เซ็นต์ของรายได้ เพื่อให้คุณเริ่มต้นได้ด้วยต้นทุนล่วงหน้าน้อยที่สุด',
    q6: 'คุณจัดการอะไรได้บ้างหากฉันพบว่าการจัดการด้วยตนเองเป็นเรื่องยาก?',
    a6: 'เราสามารถจัดการทุกอย่างได้ ตั้งแต่การจัดการการจอง การสื่อสารกับแขก การประสานงานการทำความสะอาด การส่งมอบกุญแจ การแก้ไขปัญหา และรายงานรายได้รายเดือน เจ้าของทรัพย์สินสามารถดำเนินการ Airbnb แบบไม่ต้องลงมือเองได้อย่างแท้จริง',
    q7: 'ฉันสามารถเปิด Airbnb ในคอนโดมิเนียมได้หรือไม่?',
    a7: 'การเปิด Airbnb ในคอนโดมิเนียมเป็นไปได้ตราบใดที่ไม่ถูกห้ามโดยกฎการจัดการอาคาร คุณต้องตรวจสอบกฎระเบียบการจัดการก่อนเพื่อยืนยันว่าไม่มีข้อกำหนดที่ห้ามกิจกรรมที่พักหรือการเช่าระยะสั้น',
    q8: 'ฉันกังวลเรื่องการร้องเรียนจากเพื่อนบ้าน คุณจัดการอย่างไร?',
    a8: 'เราตั้งกฎบ้านที่ชัดเจนสำหรับแขก (เสียงรบกวน การทิ้งขยะ การใช้พื้นที่ส่วนกลาง ฯลฯ) และอธิบายอย่างละเอียดเมื่อเช็คอินเพื่อป้องกันปัญหาก่อนที่จะเกิดขึ้น หากมีการร้องเรียนเกิดขึ้น เรามีระบบตอบสนอง 24 ชั่วโมงเพื่อประเมินและแก้ไขสถานการณ์อย่างรวดเร็ว',
    q9: 'ฉันสามารถคาดหวังรายได้เท่าไหร่?',
    a9: 'รายได้แตกต่างกันอย่างมากขึ้นอยู่กับที่ตั้ง ขนาด สิ่งอำนวยความสะดวก และอัตราการเข้าพักของทรัพย์สิน ในพื้นที่ยอดนิยมของโตเกียว ทรัพย์สิน 1LDK ถึง 2LDK สามารถสร้างรายได้รายเดือน ¥200,000–¥500,000 ในบางกรณี เราเสนอการจำลองรายได้ฟรีตามข้อมูลการดำเนินงานในอดีตของเรา',
    q10: 'ปรึกษาอย่างเดียวได้ไหม? จะถูกกดดันให้เซ็นสัญญาหรือเปล่า?',
    a10: 'แน่นอน การปรึกษาเพียงอย่างเดียวยินดีต้อนรับอย่างยิ่ง เราไม่เคยกดดันให้คุณเซ็นสัญญาในทันที เราหวังว่าคุณจะใช้เวลาและตัดสินใจในจังหวะของตัวเอง',
  },
  seo: {
    home: {
      title: 'Magome Kominka | บ้านญี่ปุ่นดั้งเดิมโตเกียว & บริการจัดการ Airbnb',
      description: 'พักในบ้านญี่ปุ่นดั้งเดิมที่มาโกเมะ เขตโอตะ โตเกียว — เช่าทั้งหลังสูงสุด 8 คน บริการจัดการ Airbnb มืออาชีพและสนับสนุนใบอนุญาต Minpaku โดยโฮสต์ที่ยังดำเนินงานอยู่',
      keywords: 'Magome Kominka, โตเกียว Airbnb, Ota City minpaku, บ้านญี่ปุ่นดั้งเดิม, เช่าระยะสั้นโตเกียว',
    },
    management: {
      title: 'บริการจัดการ Airbnb โตเกียว | การเช่าระยะสั้นครบวงจร',
      description: 'บริการจัดการ Airbnb มืออาชีพในโตเกียว สื่อสารกับแขก กำหนดราคาแบบไดนามิก ประสานงานทำความสะอาด และรายงานรายเดือน จัดการเช่าระยะสั้นครบวงจรสำหรับเจ้าของที่พักในโอตะและโตเกียว',
      keywords: 'จัดการ Airbnb โตเกียว, เช่าระยะสั้นโตเกียว, จัดการอสังหาริมทรัพย์โอตะ, บริการแขกโตเกียว',
    },
    support: {
      title: 'สนับสนุน Minpaku & ใบอนุญาต Ryokan โตเกียว | เปิดธุรกิจที่พัก',
      description: 'สนับสนุนผู้เชี่ยวชาญในการลงทะเบียน Minpaku และขอใบอนุญาต Ryokan ในโตเกียว คำแนะนำเชิงปฏิบัติจากโฮสต์ที่ยังดำเนินงานอยู่ในโอตะ ตั้งแต่เอกสารราชการจนถึงการสร้างรายได้',
      keywords: 'ลงทะเบียน minpaku โตเกียว, ใบอนุญาต ryokan โตเกียว, สนับสนุน Airbnb โตเกียว, เช่าระยะสั้นโอตะ',
    },
    forOwners: {
      title: 'จัดการ Airbnb โตเกียว & สนับสนุนใบอนุญาต Minpaku สำหรับเจ้าของที่พัก',
      description: 'จัดการ Airbnb ครบวงจรและสนับสนุนใบอนุญาต Minpaku สำหรับเจ้าของที่พักในโตเกียว ตั้งแต่การขอใบอนุญาตถึงการดำเนินงานประจำวันและทำความสะอาด ปรึกษาฟรีครั้งแรก',
      keywords: 'เจ้าของ Airbnb โตเกียว, สนับสนุนใบอนุญาต minpaku, จัดการอสังหาริมทรัพย์โตเกียว, Airbnb โอตะ',
    },
    pricing: {
      title: 'ราคาบริการจัดการ Airbnb โตเกียว | แผนราคาโปร่งใส',
      description: 'ราคาชัดเจนโปร่งใสสำหรับบริการจัดการ Airbnb และสนับสนุน Minpaku ในโตเกียว แพ็กเกจสนับสนุนการเปิดตัว ตั้งค่าครบ บริการจัดการ และทำความสะอาด ไม่มีค่าใช้จ่ายซ่อนเร้น',
      keywords: 'ราคาจัดการ Airbnb โตเกียว, ค่าสนับสนุน minpaku, แผนเช่าระยะสั้นโตเกียว, ค่าธรรมเนียมจัดการโตเกียว',
    },
    minpakuRegistration: {
      title: 'ลงทะเบียน Minpaku โตเกียว | คู่มือขอใบอนุญาต Ryokan ทีละขั้นตอน',
      description: 'คู่มือครบถ้วนสำหรับการลงทะเบียน Minpaku ในโตเกียว กระบวนการขอใบอนุญาต Ryokan เอกสารที่ต้องใช้ ตารางเวลา และข้อผิดพลาดที่พบบ่อย อิงจากประสบการณ์จริงในโอตะ',
      keywords: 'ลงทะเบียน minpaku โตเกียว, ใบอนุญาต ryokan โตเกียว, สนับสนุน Airbnb โตเกียว, เช่าระยะสั้นโอตะ',
    },
    guide: {
      title: 'คู่มือเริ่มต้น Minpaku โตเกียว 2026 | ใบอนุญาต รายได้ & การจัดการ',
      description: 'คู่มือครบถ้วนสำหรับเริ่มธุรกิจ Airbnb ในโตเกียว Minpaku vs Ryokan ขั้นตอนการขอใบอนุญาต ตารางเวลา ข้อผิดพลาดที่พบบ่อย การประมาณรายได้ และเมื่อใดควรใช้บริการจัดการ',
      keywords: 'คู่มือ minpaku โตเกียว, เริ่ม Airbnb โตเกียว, ใบอนุญาต minpaku, ใบอนุญาต ryokan, เช่าระยะสั้นโตเกียว',
    },
    caseStudy: {
      title: 'กรณีศึกษาเปิดตัว Minpaku โอตะ | เรื่องราวความสำเร็จ Airbnb โตเกียว',
      description: 'กรณีศึกษาจริง: เจ้าของที่พักในโอตะเปิดตัว Airbnb ใน 3.5 เดือนด้วยใบอนุญาต Ryokan ทำรายได้ ¥180,000+/เดือน และอัตราการเข้าพัก 78% การสนับสนุน Minpaku โตเกียวในทางปฏิบัติ',
      keywords: 'Ota City minpaku, กรณีศึกษา Airbnb โตเกียว, ใบอนุญาต ryokan โตเกียว, จัดการ Airbnb โตเกียว',
    },
    adsLanding: {
      title: 'เริ่มธุรกิจ Airbnb ถูกกฎหมายในโตเกียว | สนับสนุนใบอนุญาต Minpaku & Ryokan',
      description: 'สนับสนุนมืออาชีพสำหรับใบอนุญาต Minpaku และ Ryokan ในโตเกียว จัดการ Airbnb ครบวงจรโดยโฮสต์ที่ยังดำเนินงานอยู่ในโอตะ ปรึกษาฟรี 30 นาที สนับสนุนการเปิดตัวเริ่มต้น ¥300,000',
      keywords: 'Airbnb ถูกกฎหมายโตเกียว, สนับสนุนใบอนุญาต minpaku, ขอ ryokan โตเกียว, เปิดตัว Airbnb โอตะ',
    },
    airbnbGuide: {
      title: 'คู่มือกฎหมาย Airbnb โตเกียว | คู่มือครบถ้วนใบอนุญาต Minpaku & Ryokan',
      description: 'คู่มือครบถ้วนสำหรับเริ่ม Airbnb อย่างถูกกฎหมายในโตเกียว การลงทะเบียน Minpaku ข้อกำหนดใบอนุญาต Ryokan ค่าใช้จ่าย ตารางเวลา และขั้นตอนทีละขั้น อิงจากประสบการณ์จริงในโอตะ',
      keywords: 'ใบอนุญาต Airbnb โตเกียว, ลงทะเบียน minpaku โตเกียว, ใบอนุญาต ryokan โตเกียว, จัดการ Airbnb โตเกียว, เช่าระยะสั้นโอตะ',
    },
  },
  schema: {
    management: {
      offerDescription: '15%–20% ของรายได้รายเดือน',
      service1: 'การปรับราคา & การกำหนดราคาแบบไดนามิก',
      service2: 'การสื่อสารกับแขก (หลายภาษา)',
      service3: 'การจัดการรีวิว',
      service4: 'การประสานงานทำความสะอาด & ผ้าปูที่นอน',
      service5: 'รายงานรายได้รายเดือน',
      service6: 'โปรแกรมช่วยเหลือการยื่นภาษี',
    },
  },
  taxOffice: {
    badge: 'สำนักงานบัญชีและภาษี',
    sectionTitle: 'สำนักงาน Yokota — บัญชีและภาษี',
    sectionSubtitle: 'ผู้เชี่ยวชาญด้านภาษี Minpaku ที่ Higashi-Magome เขตโอตะ โตเกียว',
    businessName: 'สำนักงาน Yokota — บัญชีและภาษี',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: 'ที่อยู่',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'พื้นที่ให้บริการ',
    serviceArea: 'เขตโอตะและโตเกียวทั้งหมด',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: 'การเดินทาง',
    accessJa: 'Toei Asakusa Line — สถานี Magome',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'เปิดใน Google Maps',
    supportTitle: 'สนับสนุนภาษี Minpaku & Airbnb',
    supportItems: [
      'ระบบช่วยเหลือการยื่นภาษี (ไม่ใช่ตัวแทนยื่นภาษี)',
      'สนับสนุนภาษี Minpaku ในเขตโอตะ',
      'ปรึกษาภาษี Airbnb โตเกียว',
      'สนับสนุนภาษี Minpaku โตเกียว — ปรึกษาครั้งแรกฟรี',
      'ปรึกษาภาษี Airbnb โตเกียว — สนับสนุนการแจ้งรายได้',
    ],
    disclaimer: '※ "ระบบช่วยเหลือการยื่นภาษี" หมายถึงการช่วยเตรียมเอกสารและให้คำแนะนำ ไม่ใช่การเป็นตัวแทนยื่นภาษี',
    officeImageAlt: 'สำนักงาน Yokota — สำนักงานบัญชีที่ Higashi-Magome เขตโอตะ',
    officeImageCaption: 'สำนักงาน Yokota — Higashi-Magome เขตโอตะ โตเกียว',
    officeImageSubCaption: 'สนับสนุนภาษี Minpaku เขตโอตะ · ปรึกษาภาษี Airbnb โตเกียว',
  },
  managementContact: {
    title: 'แบบฟอร์มปรึกษาฟรี',
    name: 'ชื่อ-นามสกุล',
    nameRequired: 'จำเป็น',
    phone: 'หมายเลขโทรศัพท์',
    email: 'อีเมล',
    emailRequired: 'จำเป็น',
    propertyType: 'ประเภทอสังหาริมทรัพย์',
    propertyTypePlaceholder: 'กรุณาเลือก',
    propertyTypeOptions: {
      mansion1k: 'อพาร์ตเมนต์（Studio–1LDK）',
      mansion2ldk: 'อพาร์ตเมนต์（2LDK+）',
      house: 'บ้านเดี่ยว',
      kominka: 'บ้านดั้งเดิม',
      taxConsult: 'ปรึกษาภาษี',
      other: 'อื่นๆ',
    },
    consultContent: 'รายละเอียดการปรึกษา',
    consultContentRequired: 'จำเป็น',
    consultContentCounter: '{{count}}/500 ตัวอักษร',
    consultContentPlaceholder: 'กรุณาระบุที่ตั้ง สถานการณ์ปัจจุบัน และความต้องการของคุณ（ไม่เกิน 500 ตัวอักษร）',
    submit: 'สมัครปรึกษาฟรี（ฟรีทั้งหมด）',
    submitting: 'กำลังส่ง...',
    success: 'ขอบคุณสำหรับการสอบถาม เราจะติดต่อกลับภายใน 2 วันทำการ',
    error: 'ส่งไม่สำเร็จ กรุณาลองอีกครั้ง',
    beforeContact: 'ก่อนติดต่อเรา',
    infoItems: [
      'การปรึกษาครั้งแรกฟรีทั้งหมด',
      'ให้บริการหลักในพื้นที่โตเกียว',
      'ตอบกลับภายใน 2 วันทำการ',
      'ข้อมูลส่วนตัวของคุณได้รับการปกป้องอย่างเข้มงวด',
    ],
    recommendTitle: 'แนะนำให้ปรึกษาหากคุณ…',
    recommendItems: [
      'มีอสังหาริมทรัพย์แต่ไม่สามารถจัดการเองได้',
      'ต้องการเริ่ม Minpaku เป็นอาชีพเสริม',
      'ไม่พอใจกับรายได้ปัจจุบัน',
      'กำลังมองหาบริการทำความสะอาด',
      'ไม่รู้วิธีใช้ Airbnb',
    ],
    confirmNote: 'หลังจากยืนยันการนัดหมาย เจ้าหน้าที่จะติดต่อกลับ',
  },
  privateDriver: {
    badge: 'บริการพาร์ทเนอร์',
    title: 'คนขับรถส่วนตัว',
    titleEn: 'Private Driver Service',
    description: 'คนขับรถพาร์ทเนอร์ของเราให้บริการขนส่งมืออาชีพ — ตั้งแต่รับส่งสนามบินไปจนถึงทัวร์ท่องเที่ยว',
    descriptionHighlight: 'มีคนขับที่พูดภาษาอังกฤษได้',
    featureTitle: 'ทำไมต้องเลือกบริการของเรา',
    features: [
      { title: 'คนขับพูดภาษาอังกฤษ', desc: 'คนขับมืออาชีพที่พูดภาษาอังกฤษสำหรับแขกต่างชาติ' },
      { title: 'ปลอดภัยและมีประกัน', desc: 'คนขับมืออาชีพที่มีประกันครบถ้วนรับประกันการเดินทางที่ปลอดภัยและสะดวกสบาย' },
      { title: 'พร้อมให้บริการ 24/7', desc: 'เที่ยวบินเช้าตรู่หรือมาถึงดึก — เราพร้อมเสมอด้วยการจองล่วงหน้า' },
      { title: 'กระเป๋าใหญ่ได้', desc: 'มีรถขนาดใหญ่สำหรับครอบครัว กระเป๋าหลายใบไม่ใช่ปัญหา' },
      { title: 'เส้นทางกำหนดเอง', desc: 'เส้นทางพิเศษไปยังสถานที่ย้อนยุคโชวะและสถานที่ถ่ายทำได้ตามคำขอ' },
    ],
    menuTitle: 'เมนูบริการ',
    priceGuide: 'คู่มือราคา',
    pricingTitle: 'คู่มือราคา',
    pricingNote: 'ราคาทั้งหมดรวมภาษีแล้ว เป็นเพียงการประมาณ — ติดต่อเราสำหรับใบเสนอราคาที่แน่นอน',
    discountBadge: 'ส่วนลดพิเศษ',
    discountTitle: 'สำหรับแขกเท่านั้น',
    discountOff: 'ลด 10%',
    discountSuffix: 'ส่วนลดพิเศษ',
    discountNote: 'แจ้งการเข้าพักของคุณเมื่อจองเพื่อรับส่วนลด',
    discountBtn: 'จองเลย',
    ctaBadge: 'เฉพาะแขก KOMINKA',
    ctaTitle: 'ราคาพิเศษสำหรับแขก',
    ctaDesc: 'แขก KOMINKA ได้รับส่วนลดพิเศษสำหรับบริการคนขับรถส่วนตัวของเรา',
    ctaBtn: 'จองคนขับ',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: 'รับส่งสนามบิน', subtitle: '空港送迎', desc: 'รับและส่งสนามบินฮาเนดะ/นาริตะ มีบริการ Meet & Greet', price: 'เริ่มต้น ¥8,000' },
      { title: 'ทัวร์เมืองโตเกียว', subtitle: '東京観光ドライブ', desc: 'สำรวจย่านยุคโชวะ วัด และสถานที่ซ่อนเร้นกับคนขับท้องถิ่น', price: 'เริ่มต้น ¥15,000/3ชม.' },
      { title: 'สนับสนุนการพักระยะยาว', subtitle: '長期滞在サポート', desc: 'บริการคนขับรายสัปดาห์หรือรายเดือนสำหรับช้อปปิ้งและทริปวันเดียว', price: 'เริ่มต้น ¥40,000/สัปดาห์' },
      { title: 'เดินทางไปสถานที่ถ่ายทำ', subtitle: '撮影ロケ送迎', desc: 'ขนส่งไปยังสถานที่ยุคโชวะอันเป็นสัญลักษณ์และสถานที่ถ่ายทำ', price: 'เริ่มต้น ¥12,000/2ชม.' },
    ],
    pricing: [
      { title: 'รับส่งสนามบิน', subtitle: 'Airport Transfer', rows: [{ label: 'สนามบินฮาเนดะ ⇔ มาโกเมะ (เที่ยวเดียว)', price: '¥8,000+' }, { label: 'สนามบินนาริตะ ⇔ มาโกเมะ (เที่ยวเดียว)', price: '¥14,000+' }, { label: 'ค่าเพิ่มกลางคืน (22:00–6:00)', price: '+¥2,000' }, { label: 'กระเป๋าใหญ่ (3+ ใบ)', price: '+¥1,000' }], note: '* ราคาเดียวกันสำหรับผู้โดยสารสูงสุด 4 คน' },
      { title: 'ทัวร์เมืองโตเกียว', subtitle: 'Tokyo City Tour', rows: [{ label: 'คอร์ส 3 ชั่วโมง', price: '¥15,000+' }, { label: 'คอร์ส 5 ชั่วโมง', price: '¥22,000+' }, { label: 'เต็มวัน (8 ชั่วโมง)', price: '¥35,000+' }, { label: 'เส้นทางพิเศษโชวะเรโทร', price: '+¥3,000' }], note: '* รวมค่าไกด์และที่จอดรถ' },
      { title: 'เดินทางไปสถานที่ถ่ายทำ', subtitle: 'Photo Location Drive', rows: [{ label: 'คอร์ส 2 ชั่วโมง', price: '¥12,000+' }, { label: 'คอร์ส 4 ชั่วโมง', price: '¥20,000+' }, { label: 'ตัวเลือกไกด์สถานที่', price: '+¥2,000' }, { label: 'จัดการอุปกรณ์/กระเป๋าใหญ่', price: '+¥1,500' }], note: '* ปรึกษาเส้นทางล่วงหน้าได้' },
      { title: 'สนับสนุนการพักระยะยาว', subtitle: 'Long Stay Support', rows: [{ label: 'แผนสัปดาห์ละครั้ง (4ครั้ง/เดือน)', price: '¥40,000+' }, { label: 'แผนสัปดาห์ละสองครั้ง (8ครั้ง/เดือน)', price: '¥72,000+' }, { label: 'ใช้ครั้งเดียว (3 ชั่วโมง)', price: '¥12,000+' }, { label: 'ช้อปปิ้ง/โรงพยาบาล', price: '¥6,000+/เที่ยว' }], note: '* ลด 10% เมื่อชำระรายเดือน' },
    ],
  },
};

export default common;
